var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-editor-container",staticStyle:{"margin-top":"20px"}},[_vm._v("\n  Sorry! Page in development.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }